import Checkbox from "antd/es/checkbox/Checkbox";
import React, { FC, useEffect, useState } from "react";
import { TableColumn } from "react-data-table-component";
import {ButtonBox, ErrorValidationBox, GridTable, LoadingBox} from "..";
import {
  ActionTypeEnum,
  RequestActionModel,
  RowStateEnum,
  ToastModel, ValidationErrorModel,
} from "../../models";
import { UserStorePermissionModel } from "../../models/user/userPermissionResponseModel";
import {
  getUserStorePermission,
  saveUserStorePermissions,
} from "../../serviceBroker/userApiServiceBroker";
import { getLabelName, getUserId, isArabicCurrentLanguage } from "../../utils";

export const UserStorePermissions: FC<{
  onActionEvent: (o: RequestActionModel) => void;
  setToastModel: React.Dispatch<React.SetStateAction<ToastModel>>;
}> = ({ onActionEvent = () => {}, setToastModel }) => {
  //#region variable
  const isArabic: boolean = isArabicCurrentLanguage();
  //#endregion
  //#region state
  const [validationErrors,setValidationErrors] = useState<ValidationErrorModel[]>([]);
  const userId = getUserId();
  const [loading, setLoading] = useState(false);
  const [userPermissionObject, setUserPermissionObject] = useState<
      UserStorePermissionModel[]
  >([]);
  const [searchQuery, setSearchQuery] = useState("");
  //#endregion
  //#region useEffect
  useEffect(() => {
    const fillData = async () => {
      setLoading(true);
      const permissions = await getStorePermissions(userId || 0);
      setUserPermissionObject(permissions);
      setLoading(false);
    };
    fillData().then(() => {
    });
  }, [userId]);
  //#endregion
  //#region function
  const generateColumns = (
      handleEnableChange: (isEnabled: boolean, rowID: number) => void
  ): TableColumn<UserStorePermissionModel>[] => {
    return [
      {
        name: getLabelName("Arabic Name"),
        selector: (_row, index) => _row.StoreNameAre,
      },
      {
        name: getLabelName("English Name"),
        selector: (_row, index) => _row.StoreNameEn,
      },
      {
        name: getLabelName("Active"),
        // eslint-disable-next-line react/button-has-type
        cell: (row: UserStorePermissionModel) => (
            <Checkbox
                value={row.Enabled}
                onChange={(e: any) => {
                  handleEnableChange(e.target.checked, row.ID);
                }}
                checked={row.Enabled}
                type="checkbox"
            />
        ),
      },
    ];
  };
  const getStorePermissions = async (
      id: number
  ): Promise<UserStorePermissionModel[]> => {
    return await getUserStorePermission(id, isArabic);
  };
  const handleSave = async () => {
    setValidationErrors([]);
    if (!userPermissionObject) return;
    setLoading(true);
    const data = await saveUserStorePermissions(userPermissionObject);
    onActionEvent({
      action: ActionTypeEnum.CloseModelPopup,
    });
    if (data?.Errors?.length) {
      setValidationErrors(data?.Errors)
    } else {
      setToastModel((prev) => ({
        ...prev,
        body: getLabelName("process Success"),
        variant: "success",
        show: true,
      }));
    }
    setLoading(false);
  };
  const handleEnableChange = (isEnabled: boolean, rowID: number) => {
    setUserPermissionObject((prev) => {
      const index = prev.findIndex((x) => x.ID === rowID);
      if (index === -1) return prev;
      prev[index].Enabled = isEnabled;
      prev[index].rowState = RowStateEnum.Update;
      return [...prev];
    });
  };
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value.toLowerCase());
  };
  const filteredPermissions = userPermissionObject?.filter((permission) =>
      permission.Name?.toLowerCase().includes(searchQuery)
  );
  //#endregion
  //#region html
  return (
      <>
        {<ErrorValidationBox errors={validationErrors}/>}
        <LoadingBox isLoading={loading}>
          <div className="d-flex mb-3">
            <input
                type="text"
                className="form-control"
                placeholder={getLabelName("Search by page name")}
                value={searchQuery}
                onChange={handleSearchChange}
            />
          </div>
          <GridTable
              paginationType="none"
              columns={generateColumns(handleEnableChange)}
              currentPage={1}
              data={filteredPermissions}
              pageSize={userPermissionObject?.length || 1}
              totalRows={userPermissionObject?.length || 1}
          />
          <div className="col-12 d-flex justify-content-end">
            <ButtonBox
                iconType="content-save"
                size="sm"
                type="submit"
                variant="primary"
                className="btn-gradient-primary mx-3 btn-fw"
                onClick={async () => {
                  await handleSave();
                }}
            >
              {getLabelName("save")}
            </ButtonBox>
            <ButtonBox
                iconType="receipt"
                size="sm"
                type="button"
                variant="danger"
                className="btn-fw"
                onClick={async () => {
                  onActionEvent({
                    action: ActionTypeEnum.CloseModelPopup,
                  });
                }}
            >
              {getLabelName("Close")}
            </ButtonBox>
          </div>
        </LoadingBox>
      </>
  );
  //#endregion
};
